<template lang="pug">
  div.text-center
    app-modal-notificacao(
      v-if="notification",
      :idUsuario="usuario.id",
      :notificacao="notification"
      @closeModal="closeModal()"
    )
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container(v-loading="loading")
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20",
        v-if="usuario"
      )
        p.text-center(v-if="modulos && modulos.length > 0") Clique sobre o botão correspondente ao módulo que deseja no sistema:
        p.text-center(v-else) Este usuário não possui acesso a nenhum módulo do sistema.
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20"
        v-if="usuario"
      )
        el-col(:xs="24", :sm="12", :md="8", :lg="6", :xl="4",
                v-for ="modulo in [...modulos].sort((a, b) => (a.nome > b.nome) ? 1 : -1)",
                :key="modulo.id"
              )
          .card(@click="setModulo(modulo)")
            el-card
              div(slot="header")
                img.perfil(:src="imgModulo(modulo)")
              div
                span {{ modulo.nome }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rotas from '@/constants/rotas'
import MainHeader from '@/components/MainHeader'
import AppModalNotificacao from './components/AppModalNotificacao'

export default {
  components: {
    MainHeader,
    AppModalNotificacao
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  data () {
    return {
      modulos: [],
      perfis: [],
      loading: false,
      notification: null,
      notificacoes: [],
      index: 0,
      tokenExibido: false
    }
  },

  async created () {
    this.notificacoes = await this.getMessageNotification(this.usuario.id)
    this.modulos = await this.findModulosUsuario(this.usuario.id)
    this.atualizaNotificacao()
  },

  methods: {
    ...mapActions({
      getToken: 'auth/getToken',
      selecioneModulo: 'auth/selecioneModulo',
      selecionePerfil: 'auth/selecionePerfil',
      findModulosUsuario: 'usuario/findModulosUsuario',
      findPerfisUsuario: 'usuario/findPerfisUsuario',
      getMessageNotification: 'notifications/getMessageNotification',
      getArcGis: 'arcgis/getArcGis',
      getArcGisMonitoramentoClausulas: 'arcgis/getArcGisMonitoramentoClausulas',
      getUrlInventarioPatrimonialArcGis: 'arcgis/getUrlInventarioPatrimonialArcGis'
    }),

    atualizaNotificacao () {
      this.notification = null
      const notificacoesToken = this.notificacoes.filter(notification => notification.typeNotification === 'TOKEN')
      const notificacoesOutros = this.notificacoes.filter(notification => notification.typeNotification !== 'TOKEN')
      if (notificacoesToken.length && !this.tokenExibido) {
        const notificacaoMaisRecente = notificacoesToken
          .map(notification => ({
            ...notification,
            difference: Math.abs(new Date(notification.dtAlteracaoNotificacao) - new Date())
          }))
          .sort((a, b) => a.difference - b.difference)[0]
        this.notification = notificacaoMaisRecente

        this.tokenExibido = true
      }
      if (this.index < notificacoesOutros.length) {
        this.notification = notificacoesOutros[this.index]
        this.index++
      }
    },

    async closeModal () {
      this.atualizaNotificacao()
    },

    async setModulo (modulo) {
      this.loading = true
      try {
        await this.selecioneModulo({ moduloId: modulo.id })

        this.perfis = await this.findPerfisUsuario({ idUsuario: this.usuario.id, idModulo: this.usuario.moduloSelecionado.id })
        if (this.perfis && this.perfis.length > 1) {
          this.$router.push({
            name: 'selecionarPerfil'
          })
        } else if (this.perfis && this.perfis.length === 1) {
          await this.selecionePerfil({ moduloId: this.usuario.moduloSelecionado.id, perfilId: this.perfis[0].id })
          if (rotas.EXTERNAS.includes(this.perfis[0].modulo)) {
            const token = await this.getToken()
            const tokenFormatado = process.env.NODE_ENV === 'development' ? `?token=${token}` : ''
            if (this.perfis[0].modulo === 'GESTAO_PRAZOS') {
              window.location.href = process.env.URL_GESTAO_PRAZOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'PORTARIA_PROCESSOS_FISICOS') {
              window.location.href = process.env.URL_PORTARIA_PROCESSOS_FISICOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'CARTORIOS') {
              window.location.href = process.env.URL_CARTORIOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'CREDENCIADOS') {
              window.location.href = process.env.URL_CREDENCIADOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'GEO_REURB') {
              window.location.href = process.env.URL_FLUXO_REURB + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'RELATORIOS_TITULO_CARTORIO') {
              window.location.href = process.env.URL_RELATORIOS_TITULO_CARTORIO + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'REURB') {
              window.location.href = process.env.URL_REURB_WEB + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'GESTAO_OS_REURB') {
              window.location.href = process.env.URL_GESTAO_OS_REURB + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'GESTAO_DOCUMENTOS') {
              window.location.href = process.env.URL_GESTAO_DOCUMENTOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'GESTAO_OS') {
              window.location.href = process.env.URL_GESTAO_OS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'VISTORIA') {
              window.location.href = process.env.URL_VISTORIA + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'MONITORAMENTO_DE_PROCESSOS') {
              window.location.href = process.env.URL_MONITORAMENTO_PROCESSOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'GESTAO_ANALISE_AUTOMATIZADA') {
              window.location.href = process.env.URL_GESTAO_ANALISE_AUTOMATIZADA + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'ACERVO_FUNDIARIO') {
              const retorno = await this.getArcGis()
              window.location.href = retorno.url
              return
            }
            if (this.perfis[0].modulo === 'ANALISE_CARTOGRAFICA_PROCESSOS_FISICOS') {
              window.location.href = process.env.URL_ANALISE_CARTOGRAFICA_PROCESSOS_FISICOS + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'AUTOMATIZADO_GEO') {
              window.location.href = process.env.URL_AUTOMATIZADO_GEO + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'INVENTARIO_PATRIMONIAL') {
              const retorno = await this.getUrlInventarioPatrimonialArcGis()
              window.location.href = retorno.url
              return
            }
            if (this.perfis[0].modulo === 'MONITORAMENTO_DE_CLAUSULAS_RESOLUTIVAS') {
              const retorno = await this.getArcGisMonitoramentoClausulas()
              window.location.href = retorno.url
              return
            }
            if (this.perfis[0].modulo === 'TERRAS_DO_BRASIL') {
              window.location.href = process.env.URL_TERRAS_DO_BRASIL + tokenFormatado
              return
            }
            if (this.perfis[0].modulo === 'DARSE') {
              window.location.href = process.env.URL_DARSE + '/' + token
              return
            }
            if (this.perfis[0].modulo === 'GESTAO_DE_CREDENCIADOS') {
              window.location.href = process.env.URL_GERENCIAMENTO_CREDENCIADOS + tokenFormatado
              return
            }
            window.location.href = this.perfis[0].paginaInicial + token
            return
          }
          this.$router.push({
            name: this.perfis[0].paginaInicial
          })
        } else {
          this.$router.push({
            name: modulo.url
          })
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },

    imgModulo (modulo) {
      return 'static/modulos/' + modulo?.codigo?.toLowerCase() + '.png'
    }
  }
}
</script>

<style lang="scss" scoped>

  .text-center {
    text-align: center;
  }

  .container {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    * {
      flex-wrap: wrap;
    }
  }

  .card {
    margin-bottom: 10px;
    flex-wrap: wrap;
    cursor: pointer;
    > :hover{
      transform: scale(1.05);
      transition-property: 2s;
    }
  }

  .perfil {
    width: 180px;
    height: 180px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/SelecionarModulo.vue